/* eslint-disable react/display-name */
import React from "react";
import PropTypes from "prop-types";
import ReactTable from "react-table";
import Checkbox from "../common/Checkbox";
import Loading from "../common/Loading";

const TaskList = ({ tasks, toggleTask, allTasks, saving }) => {
  const onClickCheck = (e, task) => {
    e.stopPropagation();
    toggleTask(task);
  };

  const columns = [
    {
      Header: "Added",
      accessor: "_id",
      Cell: (row) => {
        const { value } = row;
        const checked = !!tasks.find((task) => task?.task?._id === value);
        return (
          <Checkbox
            style={{ margin: "0 auto" }}
            checked={checked}
            name="all-checked"
            disabled={saving}
            onClickCheck={(e) =>
              onClickCheck(e, {
                value,
                checked
              })
            }
          />
        );
      },
      maxWidth: 80
    },
    { Header: "Description", accessor: "description" }
  ];

  return (
    <>
      <h3>Tasks</h3>
      <ReactTable
        className="-highlight"
        data={allTasks}
        LoadingComponent={() => <Loading active={!allTasks.length} />}
        columns={columns}
        defaultPageSize={10}
        defaultSorted={[
          {
            id: "description",
            asc: true
          }
        ]}
      />
    </>
  );
};

TaskList.propTypes = {
  tasks: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      description: PropTypes.string
    }).isRequired
  ).isRequired,
  saving: PropTypes.bool,
  toggleTask: PropTypes.func,
  allTasks: PropTypes.array
};

export default TaskList;
